import React,  { useState,useEffect }  from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import $ from "jquery"
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
import "../js/main.js"

const Contact = () => {
const [Notify, SetNotify] = useState("")

const submitEnquiry = () =>{  
    if(document.getElementById("fullname").value ===""){
        SetNotify("Input your fullname")
    }

    else if(document.getElementById("emailaddress").value ===""){
        SetNotify("Input your email address")
    }

    else if(document.getElementById("message").value ===""){
        SetNotify("Input your message")
    }
    

    else{
        var settingstwo = {
 
            beforeSend: function(){
                SetNotify("Submitting")
            // $('.loading').css("visibility", "visible");
            },
            "url": "https://earthvii-api.herokuapp.com/v1/enquiries/",
            "method": "POST",
            "timeout": 0,
            //  "headers": { "X-ApiKey": "SfeILETE0TcCFOziCtTXBPxfqsmTR6aO5F+3cJRmobMf/w8HEVw7xqAvAyNPlD0O"},
             "data":
             {
                 "full_name":document.getElementById("fullname").value, 
                 "email":document.getElementById("emailaddress").value, 
                 "message":document.getElementById("message").value, 
             },
             error: function(xhr, status, error) {
                 console.log(xhr.responseJSON.email)
                SetNotify(xhr.responseJSON.email)
        },
             complete: function(){
            
            }
            }
                 
            $.ajax(settingstwo).done(function (responsetwo) {
                SetNotify("Your message has been sent.")
                document.getElementById("fullname").value = ""
                document.getElementById("emailaddress").value = ""
                document.getElementById("message").value = "" 
            $('.loading').css("visibility", "hidden");
        
            })
        
    }
 
} 



return(


    <div className='hmeighthbox'>
        <div className='contactboxbg'>
        <div className='container'>
       <div class="row containerbgrow"> 
           <div class="col-md-5">
           <div class="row contactfirstnotify">
                   <div class="col-md-1 col-2">
                       {/* <h2  className="line hmsecondboxtitle"></h2> */}
                       <img style={{paddingTop:"34px" }} className="" src="images/line.png"/>

                       </div>
                       <div class="col-md-11 col-10" style={{paddingLeft:"25px" }}>
                       <h2 className=" hmsecondboxtitle fordesktoponly">  You can contact us through<br/> the followings</h2>
                       <h2 className=" hmsecondboxtitle formobileonly">  You can contact us through the followings</h2>

                       </div>
                   

               </div>
              
               <Row className="innerboxseven">
        

    
         

<div className='innersesventhbody'>
            <Row>
                <div class="col-md-1 col-2">
                    <img src="images/icons/phone2.png"/>
                </div>

                <div style={{paddingLeft:"30px"}} class="col-md-9 col-10">
                    <p> <span className='innerboxsevendescriptionicon'>Phone number</span> <br/>
                    <span><a style={{textDecoration:"none", color:"#666666"}} href="tel:234 123 456 7890">+234 901 685 4815</a></span>
                    </p>
                </div>
            </Row>

            <Row className="innersesventhbodyrow">
                <div class="col-md-1 col-2">
                    <img src="images/icons/mail2.png"/>
                </div>

                <div style={{paddingLeft:"30px"}}  class="col-md-9 col-10">
                <p> <span className='innerboxsevendescriptionicon'>Email address</span> <br/>
                    <span><a style={{textDecoration:"none", color:"#666666"}} href="mailto:hello@earthvii.com">info@earthvii.com</a></span>
                    </p>

                </div>
            </Row>

            <Row className="innersesventhbodyrow">
                <div class="col-md-1 col-2">
                    <img src="images/icons/office2.png"/>
                </div>

                <div style={{paddingLeft:"30px"}}  class="col-md-9 col-10">
                <p> <span className='innerboxsevendescriptionicon'>Address</span> <br/>
                    <span><a target="_blank" href="https://www.google.com/maps/place/Platinum+mega+mall+abuja" style={{textDecoration:"none", color:"#666666"}} >B24D, Platinum mega mall, <br/>Katampe road, Jahi Abuja</a></span>
                    </p>

          
                </div>
            </Row>

            <Row className="innersesventhbodyrow">
                <div class="col-md-1 col-2">
                    <img src="images/icons/clock2.png"/>
                </div>

                <div style={{paddingLeft:"30px"}}  class="col-md-9 col-10">

                <p> <span className='innerboxsevendescriptionicon'>Office Hours</span> <br/>
                    <span><a style={{textDecoration:"none", color:"#666666"}} href="mailto:hello@earthvii.com">Mondays - Fridays: 9am - 5pm</a></span>
                    </p>

                </div>
            </Row>
            </div>



        

   
         
    </Row>
           </div>

           <div class="col-md-1"></div>

           <div class="col-md-6 contactformbox">
        
           <div class="row ">
                   <div class="col-md-1 col-2">
                       {/* <h2  className="line hmsecondboxtitle"></h2> */}
                       <img style={{paddingTop:"34px" }} className="" src="images/line.png"/>

                       </div>
                       <div class="col-md-11 col-10" style={{paddingLeft:"25px" }}>
                       <h2 className=" hmsecondboxtitle fordesktoponly">  Do you have a message for us? We are listening</h2>
                       <h2 className=" hmsecondboxtitle formobileonly">  Do you have a message for us?<br/>We are listening</h2>

                       </div>
                   

               </div>

           <form className='hmformmobile'>
  <div class="form-group">
    <label className='hmlabel' for="">Full Name</label>
    <input type="text" class="form-control form-control-lg hminput" id="fullname" placeholder="Fullname"/>
  </div>


  <div class="form-group">
    <label className='hmlabel2' for="">Email Address</label>
    <input type="" class="form-control form-control-lg hminput" id="emailaddress" placeholder="E-mail Address"/>
  </div>

  <div class="form-group">
    <label className='hmlabel2' for="">Message</label>
    <textarea class="form-control hminput" id="message" rows="6"></textarea>
  </div>

</form>
<p>{Notify}</p>
  <p className="hmfirstboxbutton2p"><button type="" onClick={submitEnquiry} class="btn-block hmfirstboxbutton2">Send your message</button></p>


           </div>

       </div>
        </div>
        </div>
 
        
   
    </div>

 

)

};


export default Contact;